module.exports = __webpack_public_path__ + "img/QUITTING BEFORE POSTING-1-th.a37a8dd.png";